export default "__VITE_ASSET__JeVOy1er__"